import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AzavistaButtonModule } from '@azavista/components/button';
import { CustomerChatbotService } from '../types';
import { NgIf } from '@angular/common';

@Component({
  selector: 'azavista3-customer-chatbot-close-button',
  imports: [
    AzavistaButtonModule,
    NgIf,
  ],
  templateUrl: `./close-button.html`,
  styleUrl: './close-button.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseButtonComponent {
    chatBotSvc = inject(CustomerChatbotService);

    close = () => {
        this.chatBotSvc.hideTemporarily();
    };
}
